import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {GetTriggerCategoryResponseDto} from '../../models/GetTriggerCategoryResponseDto';
import {TriggerCategoriesService} from '../../services/trigger-categories.service';

@Component({
    selector: 'app-trigger-categories',
    templateUrl: './trigger-categories.component.html',
    styleUrls: ['./trigger-categories.component.css']
})
export class TriggerCategoriesComponent implements OnInit {

    @Output()
    triggerCategoryChanged = new EventEmitter<any>();
    selectedCategory: GetTriggerCategoryResponseDto;
    triggerCategories: Array<GetTriggerCategoryResponseDto>;

    constructor(private triggerCategoryService: TriggerCategoriesService) {
    }

    ngOnInit() {
        this.triggerCategoryService.getAll().subscribe(triggerCategories => {
            this.triggerCategories = triggerCategories;
            this.onTriggerCategoryChanged(this.triggerCategories[0]);
        });
    }

    onTriggerCategoryChanged(triggerCategory: GetTriggerCategoryResponseDto) {
        this.selectedCategory = triggerCategory;
        this.triggerCategoryChanged.emit(triggerCategory);
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/trigger-categories/trigger-categories.component.ts